import React from 'react';
import LexChipGroup from '../../form_sections/LexChipGroup';

class GenderSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allGenders: [],
      loaded: false,
    };
  }

  componentDidMount() {
    $.ajax({
      url: '/get_all_genders',
      dataType: 'json',
      type: 'GET',
      header: {
        'Content-Type': 'application/json',
      },
      success: (data) => {
        this.setState({
          allGenders: JSON.parse(data.data.genders),
          loaded: true,
        });
      },
      error(xhr, status, err) {
        console.log(err);
      },
    });
  }

  render() {
    if (!this.state.loaded) {
      return (
        <div className="lex-field">
          <p className="lex-field__label">Gender</p>
          <p className="lex-field__hint">Loading…</p>
        </div>
      );
    }

    const options = this.state.allGenders.map((gender) => ({
      value: gender.id,
      label: gender.name,
    }));

    return (
      <LexChipGroup
        label="Gender"
        options={options}
        value={this.props.user.gender_id}
        attribute="gender_id"
        onChange={this.props.updateUser}
        tone="blue"
        variant={this.props.variant}
      />
    );
  }
}

export default GenderSection;
